export const Events = {
  // shopify day zero modal
  activatePluginCheckboxToggled: {
    campaign: 'DAY_ZERO_SHOPIFY_MODAL',
    page: 'SHOPIFY_PLUGIN_MODAL',
    component: 'VIDEO_MODAL',
    element: 'checkbox',
    action: 'toggled',
    meta: {
      title: 'Activate_Plugin_Checkbox_Toggled',
    },
  },
  remindMeLaterClicked: {
    campaign: 'DAY_ZERO_SHOPIFY_MODAL',
    page: 'SHOPIFY_PLUGIN_MODAL',
    component: 'VIDEO_MODAL',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Remind_Me_Later_Button_Clicked',
    },
  },
  doneButtonClicked: {
    campaign: 'DAY_ZERO_SHOPIFY_MODAL',
    page: 'SHOPIFY_PLUGIN_MODAL',
    component: 'VIDEO_MODAL',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Done_Button_Clicked',
    },
  },
  embededLearnMoreCliked: {
    campaign: 'DAY_ZERO_SHOPIFY_MODAL',
    page: 'SHOPIFY_PLUGIN_MODAL',
    component: 'VIDEO_MODAL',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Learn_More_Button_Clicked',
    },
  },
  embededVideoCliked: {
    campaign: 'DAY_ZERO_SHOPIFY_MODAL',
    page: 'SHOPIFY_PLUGIN_MODAL',
    component: 'VIDEO_MODAL',
    element: 'video',
    action: 'clicked',
    meta: {
      title: 'Embeded_Video_Player_Clicked',
    },
  },
  congratulationOkClicked: {
    campaign: 'DAY_ZERO_SHOPIFY_MODAL',
    page: 'SHOPIFY_PLUGIN_MODAL',
    component: 'VIDEO_MODAL',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Ok_Button_Clicked',
    },
  },

  // first page of  DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION (Unlock profile activation)
  installCashfreePlugin: {
    campaign: 'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION',
    page: 'LANDING',
    component: 'UNLOCK_UPI_CARD',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Install_1Cashfree_Plugin_Button_Clicked',
    },
  },
  continueWithCashfreeCards: {
    campaign: 'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION',
    page: 'LANDING',
    component: 'UNLOCK_UPI_CARD',
    element: 'link',
    action: 'clicked',
    meta: {
      title: 'Continue_With_Cashfree_Cards_Link_Clicked',
    },
  },
  reachOutToUs: {
    campaign: 'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION',
    page: 'LANDING',
    component: 'UNLOCK_UPI_CARD',
    element: 'link',
    action: 'clicked',
    meta: {
      title: 'Reach_Out_To_Us_Button_Clicked',
    },
  },
  // first page of  DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION (You're Almost There! )
  letsGetStartedClicked: {
    campaign: 'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION',
    page: 'ALMOST_THERE',
    component: 'PLUGIN_SETUP',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Lets_Get_Started_Button_Clicked',
    },
  },
  reachOutToUsClicked: {
    campaign: 'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION',
    page: 'ALMOST_THERE',
    component: 'HELP_SUPPORT',
    element: 'link',
    action: 'clicked',
    meta: {
      title: 'Reach_Out_To_Us_Button_Clicked',
    },
  },
  // second page of  DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION
  domainClicked: {
    campaign: 'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION',
    page: 'CONFIRM_DETAILS',
    component: 'DOMAIN_SELECTION',
    element: 'checkbox',
    action: 'toggled',
    meta: {
      title: 'Your_Domain_Toggled',
    },
  },
  addNewDomainClicked: {
    campaign: 'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION',
    page: 'CONFIRM_DETAILS',
    component: 'DOMAIN_SELECTION',
    element: 'link',
    action: 'clicked',
    meta: {
      title: 'Add_New_Domain_Link_Clicked',
    },
  },
  addNewPyClicked: {
    campaign: 'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION',
    page: 'CONFIRM_DETAILS',
    component: 'PAYMENT_METHODS',
    element: 'link',
    action: 'clicked',
    meta: {
      title: 'Add_New_Payment_Method_Clicked',
    },
  },
  paymentMethodToggled: {
    campaign: 'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION',
    page: 'CONFIRM_DETAILS',
    component: 'PAYMENT_METHODS',
    element: 'checkbox',
    action: 'toggled',
    meta: {
      title: 'Your_Payment_Method_Toggled',
    },
  },
  installCashfreePluginClicked: {
    campaign: 'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION',
    page: 'CONFIRM_DETAILS',
    component: 'PLUGIN_INSTALLATION',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Install_Cashfree_Plugin_Button_Clicked',
    },
  },
  confirmDetailsLookGood: {
    campaign: 'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION',
    page: 'CONFIRM_DETAILS',
    component: 'PLUGIN_INSTALLATION',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Looks_Good_Button_Clicked',
    },
  },
  activateNowClicked: {
    campaign: 'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION',
    page: 'ACTIVATE_PAYMENTS',
    component: 'PLUGIN_ACTIVATION',
    element: 'link',
    action: 'clicked',
    meta: {
      title: 'Activate_Now_Link_Clicked',
    },
  },
  markAsDoneClicked: {
    campaign: 'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION',
    page: 'ACTIVATE_PAYMENTS',
    component: 'CONFIRM_ACTIVATION',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Mark_as_Done_Button_Clicked',
    },
  },
  helpVideoPlayed: {
    campaign: 'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION',
    page: 'ACTIVATE_PAYMENTS',
    component: 'HELP_VIDEO',
    element: 'video',
    action: 'played',
    meta: {
      title: 'Help_Video_Played',
    },
  },
  // 3rdpage DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION
  firstOrderShowMeHowClicked: {
    campaign: 'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION',
    page: 'CONGRATULATIONS',
    component: 'FIRST_ORDER_GUIDE',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Show_Me_How_Button_Clicked',
    },
  },
  dashboardTakeMeThereClicked: {
    campaign: 'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION',
    page: 'CONGRATULATIONS',
    component: 'DASHBOARD_REDIRECT',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Take_Me_There_Button_Clicked',
    },
  },
  finishSetupNowClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHECKOUT_JOURNEY',
    component: 'GET_STARTED_MODAL',
    element: 'button',
    action: 'click',
    meta: {
      title: 'Finish_setup_now',
    },
  },
  choiceCardClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHOICE_SCREEN',
    component: 'CHOICE_CARD',
    element: 'button',
    action: 'clicked',
  },

  platformSelectionTabClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'PLATFORM_SELECTION',
    component: 'TAB',
    element: 'button',
    action: 'clicked',
  },

  platformOptionCardClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'PLATFORM_SELECTION',
    component: 'CHECKOUT_CARD',
    element: 'button',
    action: 'clicked',
  },

  pluginClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'PLATFORM_SELECTION',
    component: 'PLUGIN_BUTTON',
    element: 'button',
    action: 'clicked',
  },

  pluginProceedClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'PLATFORM_SELECTION',
    component: 'PROCEED',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'proceed',
    },
  },

  letsGetStartedButtonClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'INTEGRATION',
    component: 'BUTTON',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Lets_Get_Started',
    },
  },

  procureSandboxAPIKeysButtonClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHECKOUT_INTEGRATION',
    component: 'BUTTON',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Procure_Sandbox_API_Keys',
    },
  },
  integrateInSandboxButtonClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHECKOUT_INTEGRATION',
    component: 'BUTTON',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Integrate_In_Sandbox',
    },
  },
  setUpWebhooksButtonClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHECKOUT_INTEGRATION',
    component: 'BUTTON',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Set_Up_Webhooks',
    },
  },
  whitelistSitePackageButtonClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHECKOUT_INTEGRATION',
    component: 'BUTTON',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Whitelist_Site_Package',
    },
  },
  checkPaymentMethodsButtonClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHECKOUT_INTEGRATION',
    component: 'BUTTON',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Check_Payment_Methods',
    },
  },
  confirmSettlementBankDetailsButtonClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHECKOUT_INTEGRATION',
    component: 'BUTTON',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Confirm_Settlement_Bank_Details',
    },
  },
  procureProductionAPIKeysButtonClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHECKOUT_INTEGRATION',
    component: 'BUTTON',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Procure_Production_API_keys',
    },
  },

  updateBaseAPISDKButtonClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHECKOUT_INTEGRATION',
    component: 'BUTTON',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Update_Base_API_SDK',
    },
  },
  updateWebhookUrlButtonClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHECKOUT_INTEGRATION',
    component: 'BUTTON',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Update_Webhook_Url',
    },
  },
  customiseCheckoutButtonClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHECKOUT_INTEGRATION',
    component: 'BUTTON',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Customise_Checkout',
    },
  },
  letsTryItOutButtonClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHECKOUT_INTEGRATION',
    component: 'BUTTON',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Lets_Try_It_Out',
    },
  },

  finishButtonClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHECKOUT_INTEGRATION',
    component: 'BUTTON',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Finish',
    },
  },

  previousButtonClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHECKOUT_INTEGRATION',
    component: 'BUTTON',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Previous',
    },
  },

  proceedButtonClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHECKOUT_INTEGRATION',
    component: 'BUTTON',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Proceed',
    },
  },

  continueSetupButtonClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHECKOUT_JOURNEY',
    component: 'I_WILL_DO_THIS_LATER',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Continue_Setup',
    },
  },

  skipToDashboardClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHECKOUT_JOURNEY',
    component: 'I_WILL_DO_THIS_LATER',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Skip_To_Dashboard',
    },
  },

  iWillDoThisLaterClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHECKOUT_JOURNEY',
    component: 'I_WILL_DO_THIS_LATER',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'I_Will_Do_This_Later',
    },
  },

  previousScreenButtonClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'CHECKOUT_JOURNEY',
    component: 'PREVIOUS_BUTTON',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Previous',
    },
  },

  continueToDashboardClicked: {
    campaign: 'DAY_ZERO_CHECKOUT_JOURNEY',
    page: 'SUCCESS',
    component: 'SUCCESS_BUTTON',
    element: 'button',
    action: 'clicked',
    meta: {
      title: 'Continue_To_Dashboard',
    },
  },
};
